{
  "common.close": "Fechar",
  "common.athleteFallback": "atleta {id}",
  "splash.title": "{app} — visualização animada de atividades",
  "splash.tagline": "Seus dados do Strava&nbsp;em movimento",
  "splash.demo": "Demonstração",
  "tab.query.title": "Mapa de {name}",
  "tab.query.heading": "Consulta de atividades:",
  "tab.query.optDays": "últimos dias",
  "tab.query.optActivities": "últimas atividades",
  "tab.query.optIds": "IDs de atividades",
  "tab.query.optDates": "Intervalo de datas",
  "tab.query.idsPlaceholder": "digite os IDs das atividades aqui",
  "tab.query.after": "De:",
  "tab.query.before": "Até:",
  "tab.query.autozoom": "Zoom automático <i class=\"hf hf-bullseye\"></i> na consulta após importar",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Consultar",
  "tab.query.createAccount": "Crie uma conta ou entre.",
  "tab.query.sports": "Esportes:",
  "tab.query.allSports": "Todos os esportes",
  "tab.query.sportsExcept": "Todos exceto",
  "tab.query.sportsNone": "Nenhum",
  "tab.query.loadingSports": "Carregando esportes…",
  "tab.query.sportsFailed": "Não foi possível carregar os esportes deste mapa",
  "tab.query.noSports": "Nenhuma atividade ainda",
  "tab.activities.title": "Atividades exibidas",
  "tab.activities.clearSelection": "Limpar seleção",
  "tab.activities.renderSelected": "Exibir seleção",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoom na seleção",
  "tab.controls.title": "Configurações da camada",
  "tab.controls.timescale": "Escala de tempo <i>&tau;</i>",
  "tab.controls.timescaleHint": "velocidade de reprodução",
  "tab.controls.period": "Período <i>T</i>",
  "tab.controls.periodHint": "atividade ~ modelo",
  "tab.controls.dotSize": "Tamanho dos pontos",
  "tab.controls.pathWidth": "Espessura do traçado",
  "tab.controls.pathWidthHint": "zero oculta os traçados",
  "tab.controls.colors": "Cores",
  "tab.controls.colorsHint": "girar a paleta",
  "tab.controls.shadows": "Sombras",
  "tab.profile.loginTitle": "Entrar",
  "tab.profile.anonNote": "Entre com o Strava para ver suas próprias atividades e gerenciar sua conta do Heatflask.",
  "tab.profile.loginLink": "Entrar com o Strava",
  "tab.profile.editOnStrava": "Editar seu perfil no Strava",
  "tab.profile.indexNote": "Indexamos os resumos das suas atividades para acesso rápido.",
  "tab.profile.viewIndex": "Ver índice",
  "tab.profile.sharedMaps": "Mapas compartilhados",
  "tab.profile.sharedMapsNote": "Desativado: só você vê suas atividades no Heatflask. Ativado: qualquer pessoa com um link para o seu mapa vê as atividades que você tornou públicas no Strava. As privadas continuam sendo só suas. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Como funciona a privacidade</a>",
  "tab.profile.logout": "Sair",
  "tab.profile.deleteAccount": "Excluir conta",
  "tab.profile.deleteConfirm": "Excluir sua conta do Heatflask?\n\nIsso remove suas atividades indexadas e revoga o acesso do Heatflask aos seus dados do Strava. Não é possível desfazer.",
  "tab.profile.languageHeading": "Idioma",
  "tab.profile.languageAuto": "Automático",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Ajude a corrigir ou adicionar traduções!</a>",
  "tab.profile.unitsHeading": "Unidades",
  "tab.profile.unitsAuto": "Automático",
  "tab.profile.unitsMetric": "Métrico (km, m)",
  "tab.profile.unitsImperial": "Imperial (mi, ft)",
  "tab.profile.textSizeHeading": "Tamanho do texto",
  "tab.profile.textSmaller": "Menor",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Maior",
  "tab.profile.mapDefaultsHeading": "Padrões do mapa",
  "tab.profile.mapDefaultsNote": "Começar com este mapa base, relevo e configurações de camada sempre que você abrir um mapa cujo link não defina os seus. Os links que você compartilha continuam mostrando exatamente o que você vê.",
  "tab.profile.mapDefaultsSave": "Salvar como meus padrões",
  "tab.profile.mapDefaultsForget": "Esquecer",
  "tab.info.title": "Informações",
  "tab.info.controlsHeading": "Controles",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + arrastar",
  "tab.info.shiftDragDesc": "Selecione atividades dentro de um retângulo. Em tela sensível ao toque, toque primeiro em <i class=\"hf-object-group\"></i> e depois arraste com um dedo. A última atividade selecionada mostra seus detalhes, e a lista rola até ela.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + arrastar",
  "tab.info.ctrlDragDesc": "Girar e inclinar o mapa em 3D, ou usar dois dedos",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Abrir ou fechar a barra lateral",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Aba anterior ou próxima",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Fechar a barra lateral",
  "tab.info.liveUrlHeading": "URL ao vivo",
  "tab.info.liveUrlDesc": "A vista do mapa e as configurações da animação ficam na URL da página, então quem receber o link vê exatamente a mesma coisa.",
  "tab.info.videoHeading": "Exportar vídeo",
  "tab.info.videoDesc": "O botão <i class=\"hf-video-camera\"></i> grava a animação em MP4: toque nele, ajuste o retângulo sobre a parte do mapa que quiser e toque de novo para gravar. É gravado um ciclo completo da animação, de modo que o vídeo se repete sem emendas; um ciclo maior que {max} segundos (o vídeo mais longo que o Strava aceita) é cortado em {max}.",
  "tab.info.contributeHeading": "Contribuir",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Patrocinar no GitHub",
  "tab.info.contactsHeading": "Contatos",
  "map.basemapAndTerrain": "Mapa base e relevo",
  "map.pauseAnimation": "Pausar a animação",
  "map.resumeAnimation": "Retomar a animação",
  "capture.record": "Gravar vídeo (ciclo de {period} s)",
  "capture.recordTruncated": "Gravar vídeo (um ciclo dura {period} s; só os primeiros {max} s serão gravados)",
  "capture.recordArea": "Gravar a área dentro do retângulo",
  "capture.stop": "Parar a gravação",
  "capture.selectionTooSmall": "a seleção é pequena demais",
  "capture.saved": "{name} salvo ({size})",
  "capture.cancelled": "gravação cancelada",
  "capture.failed": "falha na gravação: {error}",
  "capture.loadingEncoder": "carregando o codificador…",
  "capture.waitingForMap": "aguardando o mapa carregar…",
  "capture.encoding": "codificando… {percent} %",
  "capture.finalizing": "finalizando…",
  "share.title": "Compartilhar um link para este mapa",
  "share.copied": "link copiado",
  "share.copiedUnshared": "link copiado — mas seu mapa não está compartilhado, então ninguém mais consegue abri-lo. Ative “Mapas compartilhados” para mudar isso.",
  "share.unshared": "Seu mapa não está compartilhado, então ninguém mais consegue abrir este link. Ative “Mapas compartilhados” para mudar isso.",
  "share.copyThis": "Copie este link:",
  "update.available": "Uma nova versão do Heatflask está disponível.",
  "update.reload": "Recarregar",
  "import.title": "Importando",
  "import.stop": "Parar",
  "import.stopping": "parando…",
  "import.contacting": "conectando ao Strava…",
  "import.countOf": "Atividades: {received} de {total}",
  "import.count": "Atividades: {received}",
  "import.waitStrava": "Pausado até {time} pelo limite de downloads do Strava. Deixe esta página aberta; recarregar não acelera.",
  "import.waitRationed": "Seus downloads rápidos de hoje acabaram. O restante continua às {time}, mais devagar. Deixe esta página aberta.",
  "import.dailyLimit": "O limite diário de downloads do Strava acabou. Tente de novo depois das {time}.",
  "import.dailyRationed": "Você já usou sua cota de downloads do Strava hoje. Tente de novo depois das {time}.",
  "import.noActivitiesYet": "Sua conta do Strava ainda não tem atividades. Grave ou envie uma no Strava e ela aparecerá aqui.",
  "table.noActivities": "nenhuma atividade",
  "table.untitled": "(sem título)",
  "activities.pageTitle": "{app} — índice de atividades",
  "activities.heading": "Índice de atividades",
  "activities.fetching": "Buscando atividades...",
  "activities.rateLimit": "Limite de requisições do Strava atingido; retomando às {time}",
  "activities.noData": "Desculpe, nenhum dado &#128577;",
  "activities.colServerCache": "Traçado em cache no servidor (Mongo)",
  "activities.colBrowserCache": "Traçado em cache neste navegador",
  "activities.cachedServer": "O traçado de {id} está em cache no servidor",
  "activities.notCachedServer": "O traçado de {id} não está em cache no servidor",
  "activities.cachedBrowser": "O traçado de {id} está em cache neste navegador",
  "activities.notCachedBrowser": "O traçado de {id} não está em cache neste navegador",
  "sport.AlpineSki": "Esqui alpino",
  "sport.BackcountrySki": "Esqui de travessia",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basquete",
  "sport.Canoeing": "Canoagem",
  "sport.Cricket": "Críquete",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Dança",
  "sport.EBikeRide": "Pedal de e-bike",
  "sport.Elliptical": "Elíptico",
  "sport.EMountainBikeRide": "Pedal de e-MTB",
  "sport.Golf": "Golfe",
  "sport.GravelRide": "Pedal gravel",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Trilha",
  "sport.IceSkate": "Patinação no gelo",
  "sport.InlineSkate": "Patins em linha",
  "sport.Kayaking": "Caiaque",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Pedal de MTB",
  "sport.NordicSki": "Esqui cross-country",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fisioterapia",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Raquetebol",
  "sport.Ride": "Pedal",
  "sport.RockClimbing": "Escalada",
  "sport.RollerSki": "Rollerski",
  "sport.Rowing": "Remo",
  "sport.Run": "Corrida",
  "sport.Sail": "Vela",
  "sport.Skateboard": "Skate",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Raquetes de neve",
  "sport.Soccer": "Futebol",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Simulador de escada",
  "sport.StandUpPaddling": "Stand up paddle",
  "sport.Surfing": "Surfe",
  "sport.Swim": "Natação",
  "sport.TableTennis": "Tênis de mesa",
  "sport.Tennis": "Tênis",
  "sport.TrailRun": "Trail running",
  "sport.Velomobile": "Velomóvel",
  "sport.VirtualRide": "Pedal virtual",
  "sport.VirtualRow": "Remo virtual",
  "sport.VirtualRun": "Corrida virtual",
  "sport.Volleyball": "Vôlei",
  "sport.Walk": "Caminhada",
  "sport.WeightTraining": "Musculação",
  "sport.Wheelchair": "Cadeira de rodas",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Treino",
  "sport.Yoga": "Ioga"
}
